<script setup lang="ts">
import { cva, VariantProps } from 'class-variance-authority'

import { classMerge } from '@toni/brand-ui'

const merchantNameVariants = cva(
  'text-heading-xs font-heading line-clamp-1',
  {
    variants: {
      variant: {
        primary: 'text-neutral-950',
        highlighted: 'text-white'
      },
      size: {
        md: 'leading-[1.5rem]',
        lg: 'leading-[1.75rem]'
      }
    },
    defaultVariants: {
      variant: 'primary',
      size: 'lg'
    }
  }
)

type MerchantNameProps = VariantProps<typeof merchantNameVariants>

withDefaults(
  defineProps<{
    name: string,
    size?: MerchantNameProps['size'],
    variant?: MerchantNameProps['variant']
}>(),
  {
    size: 'lg',
    variant: 'primary'
  }
)

</script>

<template>
  <span :class="classMerge(merchantNameVariants({ size, variant }))">
    {{ name }}
  </span>
</template>
